import Invoice from '../../models/Invoice'


export const InvoiceModule = {
  namespaced: true,

  state: {
    invoice: new Invoice({})
  },

  getters: {
    invoice (state) {
      return state.invoice
    }
  },

  mutations: {
    setInvoice (state, invoice) {
      state.invoice = new Invoice(invoice)
    }
  }
}

export default InvoiceModule
